import React from 'react';
import { Controller } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { getJaecooSiteLang } from '../../../../../utils/cookie';
import styles from './FleetCustomPhoneInputField.module.scss';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

// 获取当前语言
const getCurrentLanguage = (location) => {
  const cookieLang = getJaecooSiteLang();
  if (cookieLang) return cookieLang;

  const path = location.pathname;
  if (path.startsWith('/en')) return 'en';
  if (path.startsWith('/nl')) return 'nl';
  return 'en';
};

// 荷兰语格式：只支持手机号，31开头，保留31后一个空格
const formatPhoneNL = (digits) => {
  let v = digits.replace(/\D/g, '');
  if (!v) return '';

  // 确保以 31 开头（荷兰国家代码）
  if (v[0] !== '3' || v[1] !== '1') {
    // 如果以 0 开头，去掉 0 再添加 31
    if (v[0] === '0') {
      v = '31' + v.slice(1);
    } else {
      v = '31' + v;
    }
  }

  // 格式化为 31 612345678 (31后一个空格，后面无空格)
  if (v.length <= 2) {
    return '+' + v;
  } else {
    return '+' + v.slice(0, 2) + ' ' + v.slice(2);
  }
};

// 统一使用荷兰格式（英文版和荷兰版一致）
const formatPhone = (digits, language) => {
  // 无论什么语言都使用荷兰格式
  return formatPhoneNL(digits);
};

const FleetCustomPhoneInputField = ({ placeholder, control, name, error, trigger }) => {
  const location = useLocation();
  const currentLang = getCurrentLanguage(location);
  return (
    <div className={styles.phoneNumberInputContainer}>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange, onBlur, ref } }) => {
          const displayValue = formatPhone(value || '', currentLang);

          // 统一使用荷兰格式的输入处理逻辑
          const handleChange = (e) => {
            // 无论什么语言都使用荷兰格式：只支持手机号，31开头，总共12位数字
            const justDigits = e.target.value.replace(/\D/g, '');
            const raw = justDigits.slice(0, 11);
            onChange(raw);
          };

          // 统一使用荷兰格式的 pattern
          const getPattern = () => {
            // 无论什么语言都使用荷兰格式：31 6123456789 (31后一个空格，10位数字)
            return '\\d{2}\\s\\d{9}';
          };

          // 处理输入逻辑
          const handleChange2 = (phone, onChange, countryData) => {
            let digits = phone.replace(/\D/g, '');

            // 如果是荷兰，强制 31 开头 + 最多 9 位
            if (countryData?.countryCode === 'nl') {
              if (!digits.startsWith('31')) {
                digits = '31' + digits.replace(/^0+/, '');
              }
              digits = digits.slice(0, 11); // 31 (2位) + 9 位手机号
            }

            // onChange(digits);
          };

          // 将纯数字格式化为 +31 612345678
          const formatDisplayValue = (digits) => {
            if (!digits) return '+31 ';
            if (!digits.startsWith('31')) return '+31 ';

            const cc = digits.slice(0, 2); // 国家码 31
            const number = digits.slice(2); // 手机号部分
            return `+${cc} ${number}`;
          };

          return (
            // <input
            //   ref={ref}
            //   type="text"
            //   placeholder={placeholder}
            //   className={styles.phoneInputInput}
            //   value={displayValue}
            //   onChange={handleChange}
            //   onBlur={() => {
            //     trigger(name);
            //     onBlur();
            //   }}
            //   pattern={getPattern()}
            // />
            <PhoneInput
              country={'nl'} // 默认荷兰
              // onlyCountries={['nl']} // 仅荷兰
              countryCodeEditable={false}
              disableDropdown={false} // 仍显示国旗选择，但只有荷兰
              placeholder={placeholder}
              // value={formatDisplayValue(value || '')}
              value={value || ''}
              onChange={(phone, countryData) => {
                // 如果切换到荷兰，检查是否超长 → 截断
                if (countryData?.countryCode === 'nl') {
                  const digits = (phone || '').replace(/\D/g, '').slice(0, 11);
                  onChange(digits);
                } else {
                  onChange((phone || '').replace(/\D/g, ''));
                }
              }}
              // onKeyDown={(e) => {
              //   const digits = (value || '').replace(/\D/g, '').slice(2);
              //   if (digits.length >= 9 && e.key >= '0' && e.key <= '9') {
              //     e.preventDefault();
              //   }
              // }}
              onBlur={() => {
                trigger(name);
                onBlur();
              }}
              inputProps={{
                name,
                ref,
                ...(value?.startsWith('31') // 只有荷兰时加 maxLength
                  ? { maxLength: 14 } // +31 + 空格 + 9 位手机号
                  : {}),
              }}
              className={styles.phoneInput2Box}
              inputClass={styles.phoneInput2}
              buttonClass={styles.flagDropdownBtn}
            />
          );
        }}
      />
      {error && <p className={styles.errorText}>{error}</p>}
    </div>
  );
};

export default FleetCustomPhoneInputField;
